import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import "tippy.js/animations/shift-away.css";
import "tippy.js/dist/border.css";
import "../../../vendor/assets/tippy/theme.css";

import { Controller as BaseController } from "@hotwired/stimulus";

export class Controller extends BaseController {
  static values = { content: String };

  connect() {
    this.tooltip = tippy(this.element, {
      allowHTML: true,
      content: this.contentValue,
      arrow: true,
      animation: "shift-away",
      theme: "custom",
    });
  }

  disconnect() {
    if (this.tooltip) {
      this.tooltip.destroy();
    }
  }
}
